import { AgencyUserForm } from '@/modules/agencies/components/AgencyUserForm'
import { useAgencyUserForm } from '@/modules/agencies/hooks/useAgencyUserForm'

export function AgencyUserDrawer() {
  const { isOpen, isSubmitting, closeForm } = useAgencyUserForm()

  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <button
        type="button"
        aria-label="Close agency user form"
        className="absolute inset-0 bg-ink/40"
        disabled={isSubmitting}
        onClick={closeForm}
      />
      <aside
        role="dialog"
        aria-modal="true"
        aria-labelledby="agency-user-form-heading"
        className="relative z-10 flex h-full w-full max-w-md flex-col border-l-2 border-ink bg-surface shadow-none"
      >
        <div className="flex items-center justify-between border-b-2 border-ink px-6 py-4">
          <p className="font-mono text-[0.72rem] uppercase tracking-[0.14em] text-muted">
            Platform · Agency users
          </p>
          <button
            type="button"
            aria-label="Close"
            disabled={isSubmitting}
            onClick={closeForm}
            className="border-2 border-ink px-2 py-1 text-xs font-semibold uppercase tracking-[0.08em] text-ink transition-colors hover:bg-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:opacity-60"
          >
            Close
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-6">
          <AgencyUserForm />
        </div>
      </aside>
    </div>
  )
}
